import { render, staticRenderFns } from "./Selectable.vue?vue&type=template&id=451f06da"
import script from "./Selectable.vue?vue&type=script&lang=js"
export * from "./Selectable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports